export default __webpack_public_path__ + "images/f2cbe021aad17efd162c8807b6425936.png";